

import React from 'react';
import { Grid } from "@mui/material";
import Icon from '@mui/material/Icon';
import MDBox from "components/MDBox";
import SettingsCard from './SettingsCard';
import {
    Map,
    Public,
    Payment,
    Settings as SettingsIcon,
    Help as HelpIcon
} from '@mui/icons-material';

function TravelSettings() {
    const travelSections = [
        {
            title: "Trip",
            icon: <Map />,
            description: "Manage your trips and itineraries",
            route: "/trips" // Assuming a generic list route or similar
        },
        {
            title: "Website",
            icon: <Public />,
            description: "Choose a travel website template and configure your customer site",
            route: "/website"
        },
        {
            title: "CMS Publisher",
            icon: <Public />,
            description: "Publish your content to CMS",
            route: "/cms-publisher"
        },
        {
            title: "Payment Templates",
            icon: <Payment />,
            description: "Manage payment templates for trips",
            route: "/payment-templates"
        },
        {
            title: "Trip Options",
            icon: <SettingsIcon />,
            description: "Configure options for your trips",
            route: "/trip-options"
        },
        {
            title: "Trip Sub-Options",
            icon: <SettingsIcon />,
            description: "Manage sub-options for your trip options",
            route: "/trip-sub-options"
        },
        {
            title: "Departure Dates",
            icon: <Map />,
            description: "Manage departure dates and allocations",
            route: "/departure-dates"
        },
        {
            title: "Addons",
            icon: <SettingsIcon />,
            description: "Configure addons for your trips",
            route: "/addons"
        },
        {
            title: "FAQs",
            icon: <HelpIcon />,
            description: "Manage frequently asked questions for trips",
            route: "/faqs"
        },
        {
            title: "Itinerary",
            icon: <Map />,
            description: "Manage itineraries",
            route: "/itineraries"
        },
        {
            title: "Itinerary Days",
            icon: <Map />,
            description: "Manage detailed itinerary day information",
            route: "/itinerary-days"
        },
        {
            title: "Day Line Items",
            icon: <SettingsIcon />,
            description: "Manage line items for itinerary days (services, activities, etc.)",
            route: "/day-line-items"
        },
        {
            title: "Trip Logistics",
            icon: <Icon>view_module</Icon>,
            description: "Manage trip logistics and services",
            route: "/trip-components"
        },
        {
            title: "Merchant Assets",
            icon: <Icon>store</Icon>,
            description: "Manage bookable assets owned by merchants",
            route: "/merchant-assets"
        },
        {
            title: "Training Modules",
            icon: <Icon>school</Icon>,
            description: "Manage training content for guides and suppliers",
            route: "/training-modules"
        },
        {
            title: "Training Completion",
            icon: <Icon>check_circle</Icon>,
            description: "Track training completion status for guides and suppliers",
            route: "/training-completions"
        },
        {
            title: "Payment Terms",
            icon: <Payment />,
            description: "Manage payment terms and conditions",
            route: "/payment-terms"
        },
        {
            title: "Merchant Asset Inventory",
            icon: <Icon>inventory</Icon>,
            description: "Manage inventory for merchant assets",
            route: "/merchant-asset-inventories"
        },
        {
            title: "Merchant Allocation",
            icon: <Icon>assignment</Icon>,
            description: "Manage merchant allocations and pricing",
            route: "/merchant-allocations"
        },
        {
            title: "Travel Orders",
            icon: <Icon>receipt_long</Icon>,
            description: "Manage travel orders and bookings",
            route: "/travel-orders"
        },
        {
            title: "Insurances",
            icon: <Icon>security</Icon>,
            description: "Manage travel insurance policies",
            route: "/insurances"
        },
        {
            title: "Travel Order Items",
            icon: <Icon>list_alt</Icon>,
            description: "Manage travel order line items",
            route: "/travel-order-items"
        },
        {
            title: "Travel Order Passengers",
            icon: <Icon>people</Icon>,
            description: "Manage travel order passengers",
            route: "/travel-order-pax"
        },
        {
            title: "Travel Order Item Passengers",
            icon: <Icon>person_add</Icon>,
            description: "Manage item-passenger relationships",
            route: "/travel-order-item-pax"
        },
        {
            title: "Order Itineraries",
            icon: <Icon>route</Icon>,
            description: "Manage order itineraries and day line items",
            route: "/order-itineraries"
        },
        {
            title: "Merchant Order Lines",
            icon: <Icon>list</Icon>,
            description: "Manage merchant order lines and fulfillment",
            route: "/merchant-order-lines"
        },
        {
            title: "Merchant Service Requests",
            icon: <Icon>mail</Icon>,
            description: "Configure when service request emails are sent and accept deadlines",
            route: "/settings/merchant-service-requests"
        },
        {
            title: "Order Coupons",
            icon: <Icon>local_offer</Icon>,
            description: "Manage order coupons and discounts",
            route: "/order-coupons"
        },
        {
            title: "Order Comms",
            icon: <Icon>email</Icon>,
            description: "Manage order communications and email templates",
            route: "/order-comms"
        },
        {
            title: "Coupons",
            icon: <Icon>local_offer</Icon>,
            description: "Manage coupons and discount codes",
            route: "/coupons"
        },
        {
            title: "Payment Transactions",
            icon: <Icon>payment</Icon>,
            description: "Manage payment transactions and processing",
            route: "/payment-transactions"
        },
        {
            title: "Order Cancellations",
            icon: <Icon>cancel</Icon>,
            description: "Manage order cancellations and refunds",
            route: "/order-cancellations"
        },
        {
            title: "Merchants",
            icon: <Icon>store</Icon>,
            description: "Manage merchant accounts and suppliers",
            route: "/merchants"
        },
        {
            title: "Travel Contacts",
            icon: <Icon>person</Icon>,
            description: "Manage travel contacts, passengers, guides, and merchants",
            route: "/travel-contacts"
        },
        {
            title: "Opportunities",
            icon: <Icon>trending_up</Icon>,
            description: "Manage opportunities and leads",
            route: "/opportunities"
        },
        {
            title: "Customers",
            icon: <Icon>people</Icon>,
            description: "Manage customer information and preferences",
            route: "/customers"
        },
        {
            title: "Pricing Categories",
            icon: <Icon>price_check</Icon>,
            description: "Manage pricing categories and models",
            route: "/pricing-categories"
        },
        {
            title: "Customer Coupons",
            icon: <Icon>card_giftcard</Icon>,
            description: "Manage customer coupons and discounts",
            route: "/customer-coupons"
        },
        {
            title: "Loyalty Rules",
            icon: <Icon>rule</Icon>,
            description: "Manage loyalty program rules and configurations",
            route: "/loyalty-rules"
        },
        {
            title: "Loyalty Ledgers",
            icon: <Icon>account_balance_wallet</Icon>,
            description: "Manage loyalty ledger transactions and point entries",
            route: "/loyalty-ledgers"
        },
        {
            title: "Loyalty Summaries",
            icon: <Icon>summarize</Icon>,
            description: "View customer loyalty summaries and point balances",
            route: "/loyalty-summaries"
        },
        {
            title: "Loyalty Tiers",
            icon: <Icon>star_rate</Icon>,
            description: "Manage loyalty program tiers and ranks",
            route: "/loyalty-tiers"
        },
        {
            title: "Referral Redemptions",
            icon: <Icon>swap_horizontal_circle</Icon>,
            description: "Manage referral redemption tiers and rules",
            route: "/referral-redemptions"
        },
        {
            title: "Referral Program Settings",
            icon: <Icon>settings_applications</Icon>,
            description: "Configure referral program rewards and currency",
            route: "/referral-program-settings"
        },
        {
            title: "Guide Onboardings",
            icon: <Icon>person_add_alt</Icon>,
            description: "Manage guide onboarding and verification",
            route: "/guide-onboardings"
        },
        {
            title: "Guide Allocations",
            icon: <Icon>assignment_ind</Icon>,
            description: "Manage guide allocations for trips and departures",
            route: "/guide-allocations"
        },
        {
            title: "Creator Onboardings",
            icon: <Icon>person_add</Icon>,
            description: "Manage creator onboarding applications",
            route: "/creator-onboardings"
        },
        {
            title: "Creators",
            icon: <Icon>star</Icon>,
            description: "Manage creators and influencers",
            route: "/creators"
        },
        {
            title: "Guide Trip Notes",
            icon: <Icon>note</Icon>,
            description: "Manage guide trip notes and daily reports",
            route: "/guide-trip-notes"
        },
        {
            title: "Referral Codes",
            icon: <Icon>qr_code</Icon>,
            description: "Manage referral codes and rewards",
            route: "/referral-codes"
        },
        {
            title: "Travel Invoices",
            icon: <Icon>receipt</Icon>,
            description: "Manage travel invoices for customers and suppliers",
            route: "/travel-invoices"
        },
        {
            title: "Travel Invoice Line Items",
            icon: <Icon>list_alt</Icon>,
            description: "Manage travel invoice line items",
            route: "/travel-invoice-line-items"
        }
    ];

    return (
        <MDBox py={3} sx={{ width: '100%' }}>
            <Grid container spacing={3}>
                {travelSections.map((section, index) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                        <SettingsCard
                            title={section.title}
                            icon={section.icon}
                            description={section.description}
                            component={null}
                            isNavigate={!!section.route}
                            navigateTo={section.route}
                        />
                    </Grid>
                ))}
            </Grid>
        </MDBox>
    );
}

export default TravelSettings;
